import React, { useState } from "react";
import { Popover, Form, Input } from 'antd';
import {
  PrinterOutlined,
} from '@ant-design/icons';
import ColorButton from "../../common/ColorButton";
import { PRINT_COLOR } from "../../constants/color";
import { URL_REPORT, URL_TANK } from "../../constants/urls";
import _ from "lodash";
import ReportButton from "../common/ReportButton";


export default function TankCertificatePrintButton (props) {
  const [visible, setVisible] = React.useState(false);
  const [form] = Form.useForm();
  const [errorMessages , setErrorMessages] = useState(null);
  const [id, setID] = React.useState(null)
  const numberWatch = Form.useWatch('no', form)

  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
  };

  React.useEffect(() => {
    if(visible){
      setID(props.original.id)
    }
  },[visible])
  
    return (
        <Popover
          title={<center>{"พิมพ์ Certificate"}</center>}
          trigger="click"
          open={visible}
          onOpenChange={handleVisibleChange}
          style={{ padding : 5} }
          content={ 
          <Form
              form={form}
              layout={'vertical'}
              style={{ width: "100%"}}
              autoComplete="off">
              <Form.Item
                  name={"no"}
                  style={{ alignItems: 'center',  justifyContent: 'center', display: 'flex' }}
                >
                  <Input autoComplete="off" style={{ width: 300 }} placeholder="No." addonBefore="No."/>
              </Form.Item>
              <Form.Item> 
                  <ReportButton
                    url={`${URL_REPORT.CERTIFICATE_OF_ANALYSIS}${id}/`} 
                    tooltip={'พิมพ์ Certificate'}
                    sentError={(e) => setErrorMessages(e)}
                    style={{float : 'right'}}
                    data={{no : numberWatch}}
                  >
                    พิมพ์
                  </ReportButton>
                  <ColorButton onClick={() => setVisible(false)} style={{ float : 'right', marginTop : 5}}>ปิด</ColorButton>
              </Form.Item>
          </Form>
          }
          >
          <ColorButton
          type="primary"
          override={PRINT_COLOR}
          icon={<PrinterOutlined/>}
          style={{margin : 5}}
          />
        </Popover>
      )
    }